import { Card, Grid } from '@mui/material';
import React, { FC, ReactElement, useEffect, useState } from 'react';
import BakeasyTextField from '../../components/textfields/BakeasyTextField';
import { t } from 'i18next';
import BakeasyHeaderLabel from '../../components/labels/BakeasyHeaderLabel';
import BakeasyTextFieldUsername, {
  BakeasyTextFieldEmailId
} from '../../components/textfields/BakeasyTextFieldUsername';
import { BakeasyButton } from '../../components/buttons/BakeasyButton';
import { BakeasyAvatar } from '../../components/common/BakeasyAvatar';
import { authActions } from '../../redux_store/slices/UpdatePassword.Slice';
import { showErrorSnackbar } from '../../redux_store/slices/snackbarSlice';
import { useAppDispatch, useAppSelector } from '../../redux_store/reduxStore';
import { modifyProfile } from '../../redux_store/slices/ProfileUpdateSlice';
import * as TextField from '../../components/textfields/BakeasyTextFields';
import { getProfile, getProfileState } from '../../redux_store/slices/GetUserProfileSlice';
import * as Dropdown from '../../components/dropdowns/BakeasySelect';
import BakeasyPaper from '../../components/common/BakesasyPaper';
import { prepareMobileNumber, validateField } from '../../utils/ValidationUtils';
import * as Regex from '../../constants/Regex';

export const Profile: FC = (): ReactElement => {
  const dispatch = useAppDispatch();

  const [name, setName] = useState<any>('');
  const [userName, setUserName] = useState<any>('');
  const [mobile, setMobile] = useState<any>('');
  const [email, setEmail] = useState<any>('');
  const [oldPassword, setOldPassword] = useState<any>('');
  const [newPassword, setNewPassword] = useState<any>('');
  const [confirmPassword, setConfirmPassword] = useState<any>('');
  const [selectedLanguage, setSelectedLanguage] = useState<any>('');

  let _userProfile: any = useAppSelector(getProfileState);

  useEffect(() => {
    setName(_userProfile?.value?.name);
    setUserName(_userProfile?.value?.userName);
    setEmail(_userProfile?.value?.email);
    setMobile(_userProfile?.value?.mobile);
    setSelectedLanguage(_userProfile?.value?.defaultLanguage);
  }, [_userProfile?.value]);

  async function getUserProfile() {
    await dispatch(getProfile(''));
  }

  useEffect(() => {
    getUserProfile();
  }, []);

  const checkValidCredentials = (): boolean => {
    if (!validateField(dispatch, 'CURRENT_PASSWORD', oldPassword)) {
      return false;
    }
    if (!validateField(dispatch, 'NEW_PASSWORD', newPassword)) {
      return false;
    }
    if (!validateField(dispatch, 'CONFIRM_PASSWORD', confirmPassword)) {
      return false;
    }
    if (newPassword !== confirmPassword) {
      let msg = `${t('NEW_PASSWORD')} ${t('CONFIRM_PASSWORD')} ${t('IS_NOT_SAME')}`;
      dispatch(showErrorSnackbar({ message: msg }));
      return false;
    }
    return true;
  };

  async function onSubmit(oldPassword: any, newPassword: any, confirmPassword: any) {
    try {
      if (checkValidCredentials()) {
        await dispatch(authActions.getUpadatedUser({ oldPassword, newPassword, confirmPassword }));
      }
    } catch (error) {
      dispatch(showErrorSnackbar({ message: error }));
    }
  }

  const checkProfileUpdateCredentials = (): boolean => {
    if (!validateField(dispatch, 'NAME', name, Regex.name)) {
      return false;
    }

    if (!validateField(dispatch, 'MOBILE', mobile, Regex.mobile)) {
      return false;
    }

    if (!validateField(dispatch, 'EMAIL', email, Regex.emailId)) {
      return false;
    }

    if (!validateField(dispatch, 'LANGUAGE', selectedLanguage)) {
      return false;
    }
    return true;
  };

  async function onSubmitProfile(language: any) {
    try {
      if (checkProfileUpdateCredentials()) {
        await dispatch(modifyProfile({ name, email, mobile, defaultLanguage: language }));
        await getUserProfile();
        if (_userProfile?.value?.defaultLanguage !== language) {
          window.location.reload();
        }
      }
    } catch (error) {
      dispatch(showErrorSnackbar({ message: error }));
    }
  }

  function profileUI() {
    return (
      <Grid>
        {/* <Grid item>
					<BakeasyAppBar
						title={t("ADMIN_USER_PROFILE")}
						onBackClick={() => {
							navigate(-1);
						}}
					/>
				</Grid> */}

        <BakeasyPaper>
          <Card sx={{ marginBottom: 2 }}>
            <Grid container sx={{ alignItems: 'center', justifyContent: 'center', marginTop: 2 }}>
              <BakeasyHeaderLabel message={t('STORE_PROFILE')}></BakeasyHeaderLabel>
            </Grid>

            <Grid container sx={{ alignItems: 'center', justifyContent: 'center' }}>
              <Grid margin={1}>
                <BakeasyAvatar value={name} isEdit={false} size={'medium'} />
              </Grid>
              {/* <BakeasyImgSelectNew
								id="profileImg"
								type="profile"
								value={userImgFile}
								label={""}
								name="profile-img"
								headerText={""}
								footerText={""}
								onChange={(file:any) => {
									setUserImgFile(file);
								}}
							/> */}
            </Grid>
            <Grid
              container
              spacing={2}
              sx={{ display: 'flex', justifyContent: 'space-between', padding: 2 }}
            >
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyTextField
                  label={t('NAME')}
                  required={true}
                  type="text"
                  name="name"
                  placeHolder={t('ENTER_NAME')}
                  value={name}
                  regexPattern={Regex.name}
                  onChange={(event: any) => {
                    setName(event.target.value);
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyTextFieldUsername
                  disabled={true}
                  required={true}
                  value={userName}
                  regexPattern={Regex.username}
                  onChange={(event: any) => {
                    setUserName(event.target.value);
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyTextFieldEmailId
                  value={email}
                  onChange={(event: any) => {
                    setEmail(event.target.value);
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <TextField.Mobile
                  value={mobile}
                  regexPattern={Regex.mobile}
                  placeHolder={t('ENTER_PHONE_NUMBER')}
                  onChange={(event: any) => {
                    setMobile(prepareMobileNumber(event.target.value));
                  }}
                />
              </Grid>
            </Grid>

            <Grid
              container
              spacing={2}
              sx={{ display: 'flex', justifyContent: 'space-between', paddingLeft: 2 }}
            >
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <Dropdown.BakeasySelectLabelLanguage
                  value={selectedLanguage}
                  required={true}
                  onChange={(e: any) => {
                    setSelectedLanguage(e.target.value);
                  }}
                />
              </Grid>
            </Grid>
            <Grid container sx={{ alignItems: 'end', justifyContent: 'end' }}>
              <Grid margin={2}>
                <BakeasyButton
                  fullWidth={false}
                  label={t('SAVE_CHANGES')}
                  onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                    onSubmitProfile(selectedLanguage);
                  }}
                />
              </Grid>
            </Grid>
          </Card>

          <Card sx={{ marginBottom: 5 }}>
            <Grid
              container
              spacing={2}
              sx={{ display: 'flex', justifyContent: 'space-between', padding: 2 }}
            >
              <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                <TextField.Password
                  label={t('CURRENT_PASSWORD')}
                  name="password"
                  type="text"
                  value={oldPassword}
                  placeHolder={t('CURRENT_PASSWORD')}
                  onChange={(event: any) => {
                    setOldPassword(event.target.value);
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                <BakeasyTextField
                  label={t('NEW_PASSWORD')}
                  required={true}
                  type="password"
                  name="text"
                  value={newPassword}
                  onChange={(event: any) => {
                    setNewPassword(event.target.value);
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                <TextField.Password
                  label={t('CONFIRM_PASSWORD')}
                  name="password"
                  type="password"
                  value={confirmPassword}
                  onChange={(event: any) => {
                    setConfirmPassword(event.target.value);
                  }}
                />
              </Grid>
            </Grid>

            <Grid container sx={{ alignItems: 'end', justifyContent: 'end' }}>
              <Grid margin={2}>
                <BakeasyButton
                  fullWidth={true}
                  label={t('CHANGE_PASSWORD')}
                  onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                    onSubmit(oldPassword, newPassword, confirmPassword);
                  }}
                />
              </Grid>
            </Grid>
          </Card>
        </BakeasyPaper>
      </Grid>
    );
  }

  return profileUI();
};
